import {Button} from '@mantine/core';
import {AiOutlineImport} from 'react-icons/ai';

import {useImportCodePipelineMutation} from '../hooks/useCodePipelinesQuery';

export const ImportSingleRecordButton = ({name}: { name: string }) => {

    const importCodePipelineMutation = useImportCodePipelineMutation();

    const handleImport = async () => {
        await importCodePipelineMutation.mutateAsync(name);
    };

    return (
        <Button
            variant='outline'
            loading={importCodePipelineMutation.isPending}
            leftSection={<AiOutlineImport/>}
            onClick={handleImport}
        >
            Import
        </Button>
    );
};
